import Operation from '@/services/operation'
import Export from '@/services/export'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const createOperation = async ({ commit }, payload = {}) => {
  return new Promise(async (resolve, reject) => {
    Operation.create(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const fetchForceRequest = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Operation.forceRequest(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const exportCnabFile = async (context, id) => {
  return new Promise((resolve, reject) => {
    Export.cnabFile(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const exportAssignmentRequestContrat = async (context, id) => {
  return new Promise((resolve, reject) => {
    Export.assignmentRequestContract(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error.response.data)
    })
  })
}

const cancelRequest = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Operation.cancelRequest(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const acceptRequest = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Operation.acceptRequest(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const cancelManyRequest = async ({ commit }, ids) => {
  return new Promise((resolve, reject) => {
    Operation.cancelManyRequest(ids).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const acceptManyRequest = async ({ commit }, ids) => {
  return new Promise((resolve, reject) => {
    Operation.acceptManyRequest(ids).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

export default {
  createOperation,
  fetchForceRequest,
  exportCnabFile,
  cancelRequest,
  acceptRequest,
  cancelManyRequest,
  acceptManyRequest,
  exportAssignmentRequestContrat
}



// WEBPACK FOOTER //
// ./src/features/operations/store/actions.js